// File: pages/AmpleEventPage.jsx

import React from 'react';
import "./AmpleEventPage.css";

import EventsHeroSection from './EventSectionsComponents/EventsHeroSection';
import TransformativeEventsSection from './EventSectionsComponents/TransformativeEventsSection';
import EventsWorkWithLeadership from './EventSectionsComponents/EventsWorkWithLeadership';
import EventsTestimonialsSection from './EventSectionsComponents/EventsTestimonialsSection';
import EventsPage from './EventsPage';

function AmpleEventPage() {

  return (

    <div className="event-page-container">

      <EventsHeroSection />

      <TransformativeEventsSection />

      <EventsWorkWithLeadership />
      <EventsPage />

      <EventsTestimonialsSection />

    </div>

  );
}

export default AmpleEventPage;